var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotsbell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "#E2F9F1",
    stroke: "#195742"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_267_9557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8876 25.2114C21.8876 26.5503 20.8022 27.6356 19.4633 27.6356C18.1244 27.6356 17.0391 26.5503 17.0391 25.2114C17.0391 23.8725 18.1244 22.7871 19.4633 22.7871C20.8022 22.7871 21.8876 23.8725 21.8876 25.2114Z",
    fill: "#2E7A61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7114 20.3155C21.6568 20.0221 20.0703 18.2554 20.0703 16.1209C20.0703 15.5148 20.1999 14.9397 20.4296 14.4178C20.1193 14.3451 19.7969 14.3027 19.4641 14.3027C17.1248 14.3027 15.2217 16.2057 15.2217 18.5451V20.2348C15.2217 21.4342 14.6963 22.5663 13.7744 23.3457C13.5387 23.5469 13.4036 23.8409 13.4036 24.1511C13.4036 24.7361 13.8793 25.2118 14.4641 25.2118H24.4641C25.0491 25.2118 25.5248 24.7361 25.5248 24.1511C25.5248 23.8409 25.3896 23.5469 25.1478 23.3403C24.2533 22.5833 23.7345 21.4845 23.7114 20.3155Z",
    fill: "#2E7A61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3419 16.1212C27.3419 17.7947 25.9852 19.1514 24.3116 19.1514C22.638 19.1514 21.2812 17.7947 21.2812 16.1212C21.2812 14.4476 22.638 13.0908 24.3116 13.0908C25.9852 13.0908 27.3419 14.4476 27.3419 16.1212Z",
    fill: "#075227"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_267_9557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.5455,
    height: 14.5455,
    fill: "white",
    transform: "translate(13.0911 13.0908)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotsbell);
export default __webpack_public_path__ + "static/media/notsbell.ee59f6c2624ce60133e1d4a34bddf573.svg";
export { ForwardRef as ReactComponent };